class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(window).on('scroll', function () {
      if ($('.mv').height() < $(this).scrollTop()) {
          $('.front-header').addClass('is-scroll');
          $('.spMenu').addClass('is-scroll');
      } else {
          $('.front-header').removeClass('is-scroll');
          $('.spMenu').removeClass('is-scroll');
      }
    });
  }
}
